import { Directive, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IAudioService, PlaybackState } from './i-audio.service';

@Directive()
export class EmptyAudioService implements IAudioService, OnDestroy {
  public static readonly instance: IAudioService = new EmptyAudioService();

  private destroySubj$: Subject<void> = new Subject<void>();

  private elapsedSecondsSubj$: BehaviorSubject<number> = new BehaviorSubject(0);
  private durationSubj$: BehaviorSubject<number> = new BehaviorSubject(0);
  private loadedSubj$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private stateSubj$: BehaviorSubject<PlaybackState> = new BehaviorSubject(PlaybackState.Reset);

  public get elapsedSeconds$(): Observable<number> {
    return this.elapsedSecondsSubj$.pipe(takeUntil(this.destroySubj$));
  }
  public get duration$(): Observable<number> {
    return this.durationSubj$.pipe(takeUntil(this.destroySubj$));
  }
  public get loaded$(): Observable<boolean> {
    return this.loadedSubj$.pipe(takeUntil(this.destroySubj$));
  }
  public get state$(): Observable<PlaybackState> {
    return this.stateSubj$.pipe(takeUntil(this.destroySubj$));
  }

  public play() {}
  public pause() {}
  public reset() {}
  public setCurrentTime() {}

  public ngOnDestroy(): void {
    this.destroySubj$.next();
  }
}
